import React from 'react'
import PropTypes from "prop-types";
import {getFormInputCssClass, hasMessage, setupOnExtractData} from "../../../util/FormUtil";
import {fetchResponseHandler} from "../../../util/FetchUtil";
import UserDataService from "../../common/UserDataService";
import {isBlank, isNotBlank} from "../../../util/StringUtil";


const PROP_NAME_PASSWORD = "password";
const PROP_NAME_CONFIRM_PASSWORD = "confirmPassword";


class PasswordInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.failClass = props.failClass ? props.failClass : " password-check--fail";
        this.passClass = props.passClass ? props.passClass : " password-check--pass";
        this.computeClassName = this.computeClassName.bind(this);
        this.passwordChange = this.passwordChange.bind(this);
        this.confirmPasswordChange = this.confirmPasswordChange.bind(this);
        this.showCalcs = this.showCalcs.bind(this);
        this.hideCalcs = this.hideCalcs.bind(this);
        this.toggleShowPassword = this.toggleShowPassword.bind(this);
        this.extractData = this.extractData.bind(this);
        this.validatePasswordMatch = this.validatePasswordMatch.bind(this);
    }

    componentDidMount() {
        const {setFormState, metadata, data, findCalcs, required = true} = this.props;

        const keys = [PROP_NAME_PASSWORD, PROP_NAME_CONFIRM_PASSWORD];
        for (let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (! metadata[key]){
                setFormState({property: key, data: data[key] ? data[key] : "", metadata: {dirty: false, valid: !required || isNotBlank(data[key]), calcs: {}, showPassword: false}});
            }
        }

        if(data[PROP_NAME_PASSWORD]){
            setFormState({property: PROP_NAME_PASSWORD, metadata: {initialPassword: data[PROP_NAME_PASSWORD]}});
        }

        setupOnExtractData(this);

        //Initial load of rules
        findCalcs();
    }

    extractData(){
        let {data, metadata} = this.props;
        let result = {
            password: data[PROP_NAME_PASSWORD]
        };

        return result;
    };

    computeClassName(passed) {
        const {metadata} = this.props;
        if(!metadata[PROP_NAME_PASSWORD].dirty && !metadata[PROP_NAME_CONFIRM_PASSWORD].dirty){
            return "";
        }else {
            if (!passed) {
                return this.failClass;
            } else {
                return this.passClass;
            }
        }
    }

    showCalcs(){
        const {setFormState, metadata} = this.props;
        setFormState({property: PROP_NAME_PASSWORD, metadata: {...metadata[PROP_NAME_PASSWORD], displayCalcs: true}})
    }

    hideCalcs(){
        const {setFormState, metadata} = this.props;
        setFormState({property: PROP_NAME_PASSWORD, metadata: {...metadata[PROP_NAME_PASSWORD], displayCalcs: false}})
    }

    toggleShowPassword(){
        const {setFormState, metadata} = this.props;
        setFormState({property: PROP_NAME_PASSWORD, metadata: {...metadata[PROP_NAME_PASSWORD], showPassword: !metadata[PROP_NAME_PASSWORD].showPassword}})
    }

    passwordChange(e){
        const {setFormState, findCalcs, metadata, data, required = true} = this.props;
        const passwordMetadata = {...metadata[PROP_NAME_PASSWORD], dirty: metadata[PROP_NAME_PASSWORD].initialPassword ? !(metadata[PROP_NAME_PASSWORD].initialPassword === e.target.value) : true};

        //Not required and empty, then set valid back to true. Covers case where user begins typing
        //in profile, then decides not to clears it out. Needs to be valid to submit
        if(!required && isBlank(e.target.value)){
            passwordMetadata['valid'] = true;
            passwordMetadata['messages'] = null;
            passwordMetadata['dirty'] = false;
            setFormState({property: PROP_NAME_CONFIRM_PASSWORD, data: null, metadata: {valid:true, message: null, dirty: false}});
        }else{
            findCalcs(passwordMetadata, PROP_NAME_PASSWORD, e.target.value);
            this.validatePasswordMatch(e.target.value, data[PROP_NAME_CONFIRM_PASSWORD]);
        }

        setFormState({property: PROP_NAME_PASSWORD, data: e.target.value, metadata: passwordMetadata});
    }

    confirmPasswordChange(e){
        const {data, setFormState} = this.props;
        setFormState({property: PROP_NAME_CONFIRM_PASSWORD, data: e.target.value});
        this.validatePasswordMatch(data[PROP_NAME_PASSWORD], e.target.value);
    }

    validatePasswordMatch(password, confirmPassword){
        const {setFormState} = this.props;
        const isValid = confirmPassword === password;
        let message = null;
        if(!isValid){
            message = "Password does not match with confirm password";
        }
        setFormState({property: PROP_NAME_CONFIRM_PASSWORD, metadata: {dirty: true, valid: isValid, message: message}});
    }

    render() {
        const {data, userDataInit, metadata, placeholder = '', isUpdatePassword} = this.props;
        let hasInputClassPassword = getFormInputCssClass(metadata, PROP_NAME_PASSWORD);
        let hasInputClassConfirmPassword = getFormInputCssClass(metadata, PROP_NAME_CONFIRM_PASSWORD);
        let passwordDisplay = metadata[PROP_NAME_PASSWORD] && metadata[PROP_NAME_PASSWORD].showPassword ? "text" : "password";
        let passwordDisplayClass= passwordDisplay === "password"?"fa fa-eye-slash-password-input":"fa fa-eye-password-input"
        return (
            <div className={"grid form-fields"}>
                <div className="grid__col-md-6 grid__col-sm-12">
                    {isUpdatePassword ? <label htmlFor={PROP_NAME_PASSWORD}>New Password</label> :
                    <label htmlFor={PROP_NAME_PASSWORD}>Password</label>}
                    <input id={PROP_NAME_PASSWORD}
                           type={passwordDisplay}
                           style={{maxHeight:'28px'}}
                           className={"text-input text-input--large password-input-with-eye "+ passwordDisplay + hasInputClassPassword}
                           value={data[PROP_NAME_PASSWORD]}
                           onChange={this.passwordChange}
                           onFocus={this.showCalcs}
                           onBlur={this.hideCalcs}
                           placeholder={placeholder}
                    />
                    <i
                        className={passwordDisplayClass}
                        style={{color:'cornflowerblue'}}
                        onClick={this.toggleShowPassword}
                    />
                    {
                        hasMessage(metadata, PROP_NAME_PASSWORD) &&
                        <div className="error display--block">{metadata[PROP_NAME_PASSWORD].message}</div>
                    }
                </div>

                <div className={" grid__col-md-6 grid__col-sm-12"}>
                    {isUpdatePassword ? <label htmlFor={PROP_NAME_CONFIRM_PASSWORD}>Confirm New Password</label> :
                        <label htmlFor={PROP_NAME_CONFIRM_PASSWORD}>Confirm Password</label>}
                    <input id={PROP_NAME_CONFIRM_PASSWORD}
                           type={passwordDisplay}
                           style={{maxHeight: '28px'}}
                           className={"text-input text-input--large " + passwordDisplay + hasInputClassConfirmPassword}
                           value={data[PROP_NAME_CONFIRM_PASSWORD]}
                           onChange={this.confirmPasswordChange}
                    />
                    <i
                        className={passwordDisplayClass}
                        style={{color:'cornflowerblue'}}
                        onClick={this.toggleShowPassword}
                    />
                    {
                        hasMessage(metadata, PROP_NAME_CONFIRM_PASSWORD) &&
                        <div className="error display--block">{metadata[PROP_NAME_CONFIRM_PASSWORD].message}</div>
                    }
                </div>

                {
                    metadata[PROP_NAME_PASSWORD] && metadata[PROP_NAME_PASSWORD].displayCalcs && metadata[PROP_NAME_PASSWORD].calcs && isNotBlank(data[PROP_NAME_PASSWORD]) &&
                    <div className="grid__col-md-12 grid__col-sm-12">
                        <div className={"float--right well well--border-color push-half--bottom uno-password-check"}>
                            <h4 className="flush--bottom">Password Rules:</h4>
                            <ul className="list--not-decorated push--left flush--bottom">
                                {
                                    Object.entries(metadata[PROP_NAME_PASSWORD] ? metadata[PROP_NAME_PASSWORD].calcs : {}).map(
                                        (calc) => {
                                            return (
                                                <li style={{display:'flex'}}>
                                                    <i className={this.computeClassName(calc[1])} style={{marginTop:'4px'}}></i><span><div dangerouslySetInnerHTML={{__html:calc[0]}}></div> </span>
                                                </li>
                                            )
                                        }
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

PasswordInputComponent.propTypes = {
    // This is the object that contains properties like country, address, etc
    data: PropTypes.object.isRequired,

    metadata: PropTypes.object.isRequired,

    // This is the function to set properties of the "data" object. The function should take property name as first parameter and the value as the second parameter.
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    findCalcs: PropTypes.func.isRequired,
    onExtractData: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    isUpdatePassword: PropTypes.bool

}

export default PasswordInputComponent;

